import React from 'react'
import { useNavigate } from 'react-router-dom'
import RecentlyViewedExplorer from '@/components/RecentlyViewed/RecentlyViewedExplorer'
import { useTrackNavigation } from '@/hooks/useTrackNavigation'

export default function RecentlyViewedContent() {
  const navigate = useNavigate()
  useTrackNavigation('navigation.recently_viewed')

  const handleBackToDashboard = () => {
    navigate('/dashboard')
  }

  return <RecentlyViewedExplorer onBack={handleBackToDashboard} />
}
